/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var e;!function(e){e[e.Immediate=0]="Immediate",e[e.Faded=1]="Faded"}(e||(e={}));export{e as Update};
